  interface SearchResult {
    item: any;
    score: number;
  }
  
  function fuzzySearch(list: any[], query: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      try {
        if (!query) {
          resolve(list);
        }
  
        const queryLower = query.toLowerCase();
  
        const results: SearchResult[] = list.map(item => {
          if (item.code.toLowerCase() == query || item.name.toLowerCase() == queryLower) {
            return { item, score: 1000 };
          } else {
            const score = calculateScore(item, queryLower);
            return { item, score };
            }
        });
  
        results.sort((a, b) => b.score - a.score);
        results.sort((a, b) => {
            if (b.score === a.score) {
                if (a.item.name.toLowerCase() < b.item.name.toLowerCase()) return -1;
                if (a.item.name.toLowerCase() > b.item.name.toLowerCase()) return 1;
                return 0;
            }
            return b.score - a.score;
        });
  
        const filteredResults = results.filter(result => result.score > 0).map(result => result.item);
  
        resolve(filteredResults);
      } catch (error) {
        reject(error);
      }
    });
  }
  
  function calculateScore(item: any, query: string): number {
    const nameLower = item.name.toLowerCase();
    let queryIndex = 0;
    let score = 0;
  
    for (let i = 0; i < nameLower.length; i++) {
      if (nameLower[i] === query[queryIndex]) {
        queryIndex++;
        score += 1;
      }
      if (queryIndex === query.length) {
        score += 10; // Bonus points for a full match
        break;
      }
    }
  
    if (nameLower.includes('unspecified')) {
      score += 50; // High bonus points for 'unspecified'
    }
  
    return score;
  }
  
  export default fuzzySearch;